import 'moment/dist/locale/es';
import moment from 'moment';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const basePath = import.meta.env.VITE_BASE_PATH || '/';
const lang = localStorage.getItem('i18nextLng');
const langForEnv = import.meta.env.VITE_ENV === 'production' ? 'es' : lang;

moment.locale(langForEnv || 'es');

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: langForEnv || 'es',
    fallbackLng: 'es',
    debug: false,
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    backend: {
      loadPath: basePath + 'locales/{{lng}}/{{ns}}.json',
      // Cache-bust per locale content (see hashLocales in vite.config.ts): without it a deploy
      // that adds keys renders them raw until the browser's cached JSON expires.
      queryStringParams: import.meta.env.VITE_LOCALES_HASH
        ? { v: import.meta.env.VITE_LOCALES_HASH }
        : undefined,
    },
    react: {
      useSuspense: false,
    },
  });

// AGI-427: start fetching the upsell banner's namespace at boot so a real
// non-client sees copy, not key paths, on first paint. Non-blocking.
// Same reason for the challenge chip: it mounts in the navbar on every page,
// so its namespace has to be in flight before the first render as well.
void i18n.loadNamespaces(['common/subscriptionBanner', 'challengeCenter/challengeCenter']);

// In production, always lock dates to Spanish regardless of language changes.
// In other envs, follow the active i18next language so moment stays in sync
// with SidebarAvatar and any other caller of i18next.changeLanguage().
i18n.on('languageChanged', (lng) => {
  const target = import.meta.env.VITE_ENV === 'production' ? 'es' : lng;
  moment.locale(moment.locales().includes(target) ? target : 'es');
});

export default i18n;
